import React from "react"; // React sempre primeiro
import { FaCircle } from "react-icons/fa6"; // Import de bibliotecas externas em seguida
import type { DataProps } from "services/api/AppWeb_Checkin/listar_checkin";
import * as S from "./styles"; // Imports relativos por último

const CIRCLE_SIZE = 24;

interface Props {
  data: DataProps | null | undefined;
}

const ContainerInfo: React.FC<Props> = (props) => {
  return (
    <S.Container>
      <S.Item>
        <FaCircle color="#ECECEC" size={CIRCLE_SIZE} />
        <S.LargeText>{props?.data?.total || "0"}</S.LargeText>
        <S.Text>Total</S.Text>
      </S.Item>
      <S.Item>
        <FaCircle color="#4CAF50" size={CIRCLE_SIZE} />
        <S.LargeText>{props?.data?.sorteio || "0"}</S.LargeText>
        <S.Text>Sorteio</S.Text>
      </S.Item>
      <S.Item>
        <FaCircle color="#F4A767" size={CIRCLE_SIZE} />
        <S.LargeText>{props?.data?.posSorteio || "0"}</S.LargeText>
        <S.Text>Pós Sorteio</S.Text>
      </S.Item>
    </S.Container>
  );
};

export default ContainerInfo;
